var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "col-12 mb-4" },
    [
      _vm.subscriptionId == "" && _vm.subloading == false
        ? _c("div", [_vm._m(0)])
        : _vm.accountExpireDate == "" && _vm.subloading == false
        ? _c("div", [
            _c("div", { staticClass: "row" }, [
              _c(
                "div",
                { staticClass: "col-12" },
                [
                  _vm.orderId != "" && _vm.orderPaymentMethod == "check"
                    ? _c(
                        "div",
                        {
                          staticClass: "bold text-center mb-2",
                          staticStyle: { color: "#E4A11B" }
                        },
                        [
                          _vm._v(
                            "Payment is pending for this account. Please click Billing button to complete the payment."
                          )
                        ]
                      )
                    : _vm.orderId != ""
                    ? _c(
                        "div",
                        {
                          staticClass: "bold text-center mb-2",
                          staticStyle: { color: "#E4A11B" }
                        },
                        [_vm._v("Payment is pending for this account.")]
                      )
                    : _c(
                        "div",
                        {
                          staticClass: "bold text-center mb-2",
                          staticStyle: { color: "#E4A11B" }
                        },
                        [
                          _vm._v(
                            "This account didn’t purchase any subscription. Please subscribe."
                          )
                        ]
                      ),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show: _vm.dismissAuthCountDown,
                        dismissible: "",
                        variant: "success"
                      },
                      on: {
                        dismissed: function($event) {
                          _vm.dismissAuthCountDown = 0
                        },
                        "dismiss-count-down": _vm.countDownAuthChanged
                      }
                    },
                    [
                      _vm._v(
                        "\n    " + _vm._s(_vm.success_auth_message) + "\n  "
                      )
                    ]
                  ),
                  _vm._v(" "),
                  _c(
                    "b-alert",
                    {
                      attrs: {
                        show: _vm.dismissCountWarningDown,
                        dismissible: "",
                        variant: "danger"
                      },
                      on: {
                        dismissed: function($event) {
                          _vm.dismissCountWarningDown = 0
                        },
                        "dismiss-count-down": _vm.countDownWarningChanged
                      }
                    },
                    [_vm._v("\n    " + _vm._s(_vm.warning_message) + "\n  ")]
                  ),
                  _vm._v(" "),
                  _vm.unitType == "Seat"
                    ? _c("div", [
                        _vm._m(1),
                        _vm._v(" "),
                        _c("div", { staticClass: "search-padd" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 override-padding order_items",
                              staticStyle: {
                                float: "left",
                                "padding-bottom": "10px !important"
                              }
                            },
                            [
                              _c(
                                "div",
                                { staticClass: "nafield_1 pl-2 pt-2" },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "custom-select billingInput",
                                    attrs: {
                                      options: _vm.frequencyoptions,
                                      disabled: _vm.reviewFlag == 1,
                                      name: "frequency"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.billingModeChangeNewAccount(
                                          $event
                                        )
                                      }
                                    },
                                    model: {
                                      value: _vm.frequency,
                                      callback: function($$v) {
                                        _vm.frequency = $$v
                                      },
                                      expression: "frequency"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "nafield_2 pl-2 pt-2" },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass: "custom-select billingInput",
                                    attrs: {
                                      options: _vm.bundleoptions,
                                      disabled: _vm.reviewFlag == 1,
                                      name: "frequency"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.frequencyChangeNewAccount()
                                      }
                                    },
                                    model: {
                                      value: _vm.bundle,
                                      callback: function($$v) {
                                        _vm.bundle = $$v
                                      },
                                      expression: "bundle"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "nafield_3 pl-2 pt-2" },
                                [
                                  _c("b-form-select", {
                                    staticClass:
                                      "col-7 custom-select billingInput",
                                    attrs: {
                                      options: _vm.seat_qty_options,
                                      name: "additionalSeatQty"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.getAdditionalPriceforNewAccountSubscription()
                                      }
                                    },
                                    model: {
                                      value: _vm.additionalSeatQty,
                                      callback: function($$v) {
                                        _vm.additionalSeatQty = $$v
                                      },
                                      expression: "additionalSeatQty"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "nafield_4 pl-2 pt-2" },
                                [
                                  _vm._v("\n        $"),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.bundlePrice,
                                        expression: "bundlePrice"
                                      }
                                    ],
                                    staticClass: "po_input col-12",
                                    staticStyle: {
                                      "line-height": "27px",
                                      width: "91% !important"
                                    },
                                    attrs: {
                                      type: "text",
                                      name: "bundlePrice",
                                      disabled: "true"
                                    },
                                    domProps: { value: _vm.bundlePrice },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.bundlePrice = $event.target.value
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "nafield_8 pl-2 pt-2" },
                                [
                                  _vm._v("\n        $"),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.overridePrice,
                                        expression: "overridePrice"
                                      }
                                    ],
                                    staticClass: "po_input col-12",
                                    staticStyle: {
                                      "line-height": "27px",
                                      width: "91% !important"
                                    },
                                    attrs: {
                                      type: "text",
                                      name: "bundlePrice"
                                    },
                                    domProps: { value: _vm.overridePrice },
                                    on: {
                                      blur: function($event) {
                                        return _vm.overridePriceSeatSubTotal()
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.overridePrice = $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.isNumericOnlyErrorMsg
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [
                                          _vm._v(
                                            "Override price should be numeric"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "nafield_5 pl-2 pt-2" },
                                [
                                  _vm._v("\n        $"),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.totalAdditionalPrice,
                                        expression: "totalAdditionalPrice"
                                      }
                                    ],
                                    staticClass: "po_input col-12",
                                    staticStyle: {
                                      "line-height": "27px",
                                      width: "91% !important"
                                    },
                                    attrs: {
                                      type: "text",
                                      name: "totalAdditionalPrice",
                                      disabled: "true"
                                    },
                                    domProps: {
                                      value: _vm.totalAdditionalPrice
                                    },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.totalAdditionalPrice =
                                          $event.target.value
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "nafield_6 pl-2  pt-2",
                                  staticStyle: {
                                    "padding-top": "15px !important"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n        $" +
                                      _vm._s(_vm.totalAmount) +
                                      "\n      "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "field_7 text-center pt-2" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-md ma-blue-btn",
                                      attrs: { type: "submit" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onBillingOpen(
                                            _vm.totalAmount
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Billing")]
                                  )
                                ]
                              )
                            ]
                          )
                        ])
                      ])
                    : _vm._e(),
                  _vm._v(" "),
                  _vm.unitType == "License"
                    ? _c("div", [
                        _vm._m(2),
                        _vm._v(" "),
                        _c("div", { staticClass: "search-padd" }, [
                          _c(
                            "div",
                            {
                              staticClass:
                                "col-12 override-padding order_items",
                              staticStyle: {
                                float: "left",
                                "padding-bottom": "10px !important"
                              }
                            },
                            [
                              _c(
                                "div",
                                {
                                  staticClass:
                                    "nafield_l_1 pl-2 pt-2 text-center"
                                },
                                [
                                  _vm._v(
                                    "\n              " +
                                      _vm._s(_vm.unitType) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "nafield_l_2 pl-2 pt-2" },
                                [
                                  _c("b-form-select", {
                                    directives: [
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required",
                                        expression: "'required'"
                                      }
                                    ],
                                    staticClass:
                                      "col-7 custom-select billingInput",
                                    attrs: {
                                      options: _vm.qty_options,
                                      name: "unit"
                                    },
                                    on: {
                                      change: function($event) {
                                        return _vm.getLicensePriceforSubscriptionNewAccount()
                                      }
                                    },
                                    model: {
                                      value: _vm.unit,
                                      callback: function($$v) {
                                        _vm.unit = $$v
                                      },
                                      expression: "unit"
                                    }
                                  })
                                ],
                                1
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "nafield_l_3 pl-2 pt-2" },
                                [
                                  _vm._v("\n              $"),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.subscriptionPrice,
                                        expression: "subscriptionPrice"
                                      },
                                      {
                                        name: "validate",
                                        rawName: "v-validate",
                                        value: "required|numeric",
                                        expression: "'required|numeric'"
                                      }
                                    ],
                                    staticClass: "po_input col-12",
                                    staticStyle: {
                                      "line-height": "27px",
                                      width: "85% !important"
                                    },
                                    attrs: {
                                      type: "text",
                                      name: "subscriptionPrice",
                                      disabled: "true"
                                    },
                                    domProps: { value: _vm.subscriptionPrice },
                                    on: {
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.subscriptionPrice =
                                          $event.target.value
                                      }
                                    }
                                  })
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "nafield_l_6 pl-2 pt-2" },
                                [
                                  _vm._v("\n              $"),
                                  _c("input", {
                                    directives: [
                                      {
                                        name: "model",
                                        rawName: "v-model",
                                        value: _vm.overrideSubscriptionPrice,
                                        expression: "overrideSubscriptionPrice"
                                      }
                                    ],
                                    staticClass: "po_input col-8",
                                    staticStyle: {
                                      "line-height": "27px",
                                      width: "91% !important"
                                    },
                                    attrs: {
                                      type: "text",
                                      name: "bundlePrice"
                                    },
                                    domProps: {
                                      value: _vm.overrideSubscriptionPrice
                                    },
                                    on: {
                                      blur: function($event) {
                                        return _vm.overridePriceSubTotal()
                                      },
                                      input: function($event) {
                                        if ($event.target.composing) {
                                          return
                                        }
                                        _vm.overrideSubscriptionPrice =
                                          $event.target.value
                                      }
                                    }
                                  }),
                                  _vm._v(" "),
                                  _vm.isNumericOnlyErrorMsg
                                    ? _c(
                                        "div",
                                        {
                                          staticClass:
                                            "margin-bottom-5 validate-warning-msg"
                                        },
                                        [
                                          _vm._v(
                                            "Override price should be numeric"
                                          )
                                        ]
                                      )
                                    : _vm._e()
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                {
                                  staticClass: "nafield_l_4 pl-2  pt-2",
                                  staticStyle: {
                                    "padding-top": "15px !important"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n              $" +
                                      _vm._s(_vm.subscriptionTotal) +
                                      "\n            "
                                  )
                                ]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "nafield_l_5 text-center pt-2" },
                                [
                                  _c(
                                    "button",
                                    {
                                      staticClass: "btn btn-md ma-blue-btn",
                                      attrs: { type: "submit" },
                                      on: {
                                        click: function($event) {
                                          return _vm.onBillingOpen(
                                            _vm.subscriptionTotal
                                          )
                                        }
                                      }
                                    },
                                    [_vm._v("Billing")]
                                  )
                                ]
                              )
                            ]
                          )
                        ]),
                        _vm._v(" "),
                        _c("div", {
                          staticClass: "mb-4",
                          staticStyle: { clear: "both" }
                        })
                      ])
                    : _vm._e()
                ],
                1
              )
            ])
          ])
        : _vm._e(),
      _vm._v(" "),
      _c(
        "div",
        {
          directives: [
            {
              name: "show",
              rawName: "v-show",
              value: _vm.subloading,
              expression: "subloading"
            }
          ],
          staticClass: "loading_show"
        },
        [_c("div", { staticClass: "spinner-border text-danger" })]
      ),
      _vm._v(" "),
      _vm.accountExpireDate != ""
        ? _c(
            "div",
            [
              _c("div", { staticClass: "row" }, [
                _c("div", { staticClass: "col-7" }, [
                  _vm._v("\n       \n    ")
                ]),
                _vm._v(" "),
                _c("div", { staticClass: "col-5 text-right" }, [
                  _c("div", { staticClass: "col-12 p-0" }, [
                    _vm._v(
                      "\n        " +
                        _vm._s(_vm.usedLicense) +
                        "/" +
                        _vm._s(_vm.totalLicenseWithoutRenew) +
                        " Mentee " +
                        _vm._s(_vm.unitType) +
                        "s Used\n      "
                    )
                  ])
                ])
              ]),
              _vm._v(" "),
              _c(
                "b-alert",
                {
                  attrs: {
                    show: _vm.dismissAuthCountDown,
                    dismissible: "",
                    variant: "success"
                  },
                  on: {
                    dismissed: function($event) {
                      _vm.dismissAuthCountDown = 0
                    },
                    "dismiss-count-down": _vm.countDownAuthChanged
                  }
                },
                [_vm._v("\n    " + _vm._s(_vm.success_auth_message) + "\n  ")]
              ),
              _vm._v(" "),
              _c(
                "b-alert",
                {
                  attrs: {
                    show: _vm.dismissCountWarningDown,
                    dismissible: "",
                    variant: "danger"
                  },
                  on: {
                    dismissed: function($event) {
                      _vm.dismissCountWarningDown = 0
                    },
                    "dismiss-count-down": _vm.countDownWarningChanged
                  }
                },
                [_vm._v("\n    " + _vm._s(_vm.warning_message) + "\n  ")]
              ),
              _vm._v(" "),
              _vm.unitType == "License"
                ? _c("div", [
                    _vm._m(3),
                    _vm._v(" "),
                    _c("div", { staticClass: "search-padd" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 override-padding order_items",
                          staticStyle: {
                            float: "left",
                            "padding-bottom": "10px !important"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "field_l_1 pl-2 pt-2 text-center" },
                            [
                              _vm._v(
                                "\n        " + _vm._s(_vm.unitType) + "\n      "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_l_2 pl-2 pt-2" },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "col-7 custom-select billingInput",
                                attrs: {
                                  options: _vm.qty_options,
                                  name: "unit"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.getLicensePriceforSubscription()
                                  }
                                },
                                model: {
                                  value: _vm.unit,
                                  callback: function($$v) {
                                    _vm.unit = $$v
                                  },
                                  expression: "unit"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "field_l_3 pl-2 pt-2" }, [
                            _vm._v("\n        $"),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.subscriptionPrice,
                                  expression: "subscriptionPrice"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric",
                                  expression: "'required|numeric'"
                                }
                              ],
                              staticClass: "po_input col-12",
                              staticStyle: {
                                "line-height": "27px",
                                width: "85% !important"
                              },
                              attrs: {
                                type: "text",
                                name: "subscriptionPrice",
                                disabled: "true"
                              },
                              domProps: { value: _vm.subscriptionPrice },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.subscriptionPrice = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "field_l_4 pl-2  pt-2",
                              staticStyle: { "padding-top": "15px !important" }
                            },
                            [
                              _vm._v(
                                "\n        $" +
                                  _vm._s(_vm.subscriptionTotal) +
                                  "\n      "
                              )
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_l_5 text-center pt-2" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-md ma-blue-btn",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onLicenseSubmit()
                                    }
                                  }
                                },
                                [_vm._v("Update")]
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "mb-4",
                      staticStyle: { clear: "both" }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.unitType == "Seat"
                ? _c("div", [
                    _c("div", { staticClass: "search-padd" }, [
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _c(
                          "div",
                          { staticClass: "crm_admin_heading field_1 pl-2" },
                          [_vm._v("Billing Frequency")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "crm_admin_heading field_2 pl-2" },
                          [_vm._v("Bundle")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "crm_admin_heading field_3 pl-2" },
                          [_vm._v("Add Mentees")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "crm_admin_heading field_4 pl-2" },
                          [_vm._v("Bundle Rate")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "crm_admin_heading field_5 pl-2" },
                          [_vm._v("Mentee Rate")]
                        ),
                        _vm._v(" "),
                        _vm.frequency == "monthly"
                          ? _c(
                              "div",
                              { staticClass: "crm_admin_heading field_6 pl-2" },
                              [_vm._v("Monthly Price")]
                            )
                          : _c(
                              "div",
                              { staticClass: "crm_admin_heading field_6 pl-2" },
                              [_vm._v("Annual Price")]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "crm_admin_heading field_7 text-center"
                          },
                          [_vm._v("Subscription")]
                        )
                      ])
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "search-padd" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 override-padding order_items",
                          staticStyle: {
                            float: "left",
                            "padding-bottom": "10px !important"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "field_1 pl-2 pt-2" },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "custom-select billingInput",
                                attrs: {
                                  options: _vm.frequencyoptions,
                                  disabled: _vm.reviewFlag == 1,
                                  name: "frequency"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.billingModeChange($event)
                                  }
                                },
                                model: {
                                  value: _vm.frequency,
                                  callback: function($$v) {
                                    _vm.frequency = $$v
                                  },
                                  expression: "frequency"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_2 pl-2 pt-2" },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "custom-select billingInput",
                                attrs: {
                                  options: _vm.bundleoptions,
                                  disabled: _vm.reviewFlag == 1,
                                  name: "frequency"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.frequencyChange()
                                  }
                                },
                                model: {
                                  value: _vm.bundle,
                                  callback: function($$v) {
                                    _vm.bundle = $$v
                                  },
                                  expression: "bundle"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_3 pl-2 pt-2" },
                            [
                              _c("b-form-select", {
                                directives: [
                                  {
                                    name: "validate",
                                    rawName: "v-validate",
                                    value: "required",
                                    expression: "'required'"
                                  }
                                ],
                                staticClass: "col-7 custom-select billingInput",
                                attrs: {
                                  options: _vm.seat_qty_options,
                                  disabled: _vm.disableAddSeat == true,
                                  name: "additionalSeatQty"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.getAdditionalPriceforSubscription()
                                  }
                                },
                                model: {
                                  value: _vm.additionalSeatQty,
                                  callback: function($$v) {
                                    _vm.additionalSeatQty = $$v
                                  },
                                  expression: "additionalSeatQty"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "field_4 pl-2 pt-2" }, [
                            _vm._v("\n        $"),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.bundlePrice,
                                  expression: "bundlePrice"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric",
                                  expression: "'required|numeric'"
                                }
                              ],
                              staticClass: "po_input col-12",
                              staticStyle: {
                                "line-height": "27px",
                                width: "91% !important"
                              },
                              attrs: {
                                type: "text",
                                name: "bundlePrice",
                                disabled: "true"
                              },
                              domProps: { value: _vm.bundlePrice },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.bundlePrice = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "field_5 pl-2 pt-2" }, [
                            _vm._v("\n        $"),
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.totalAdditionalPrice,
                                  expression: "totalAdditionalPrice"
                                },
                                {
                                  name: "validate",
                                  rawName: "v-validate",
                                  value: "required|numeric",
                                  expression: "'required|numeric'"
                                }
                              ],
                              staticClass: "po_input col-12",
                              staticStyle: {
                                "line-height": "27px",
                                width: "91% !important"
                              },
                              attrs: {
                                type: "text",
                                name: "totalAdditionalPrice",
                                disabled: "true"
                              },
                              domProps: { value: _vm.totalAdditionalPrice },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.totalAdditionalPrice = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _vm.refundFlag == 1
                            ? _c(
                                "div",
                                {
                                  staticClass: "field_6 pl-2  pt-2",
                                  staticStyle: {
                                    "padding-top": "15px !important"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n        $" +
                                      _vm._s(_vm.totalAmount) +
                                      " (Refund Amount)\n      "
                                  )
                                ]
                              )
                            : _c(
                                "div",
                                {
                                  staticClass: "field_6 pl-2  pt-2",
                                  staticStyle: {
                                    "padding-top": "15px !important"
                                  }
                                },
                                [
                                  _vm._v(
                                    "\n        $" +
                                      _vm._s(_vm.totalAmount) +
                                      "\n      "
                                  )
                                ]
                              ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "field_7 text-center pt-2" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-md ma-blue-btn",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onSubmit()
                                    }
                                  }
                                },
                                [_vm._v("Update")]
                              )
                            ]
                          )
                        ]
                      )
                    ]),
                    _vm._v(" "),
                    _vm.reviewFlag == 1
                      ? _c("div", { staticClass: "row" }, [_vm._m(4)])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "mb-4",
                      staticStyle: { clear: "both" }
                    })
                  ])
                : _vm._e(),
              _vm._v(" "),
              _vm.accountExpireDate != ""
                ? _c("div", [
                    _vm._m(5),
                    _vm._v(" "),
                    _c("div", { staticClass: "search-padd" }, [
                      _c(
                        "div",
                        {
                          staticClass: "col-12 override-padding order_items",
                          staticStyle: {
                            float: "left",
                            "padding-bottom": "10px !important"
                          }
                        },
                        [
                          _c(
                            "div",
                            { staticClass: "pfield_1 pl-2 pt-2" },
                            [
                              _c("b-form-select", {
                                staticClass: "custom-select billingInput",
                                attrs: {
                                  options: _vm.cardOptions,
                                  name: "payment_method_id"
                                },
                                on: {
                                  change: function($event) {
                                    return _vm.paymentDetails()
                                  }
                                },
                                model: {
                                  value: _vm.payment_method_id,
                                  callback: function($$v) {
                                    _vm.payment_method_id = $$v
                                  },
                                  expression: "payment_method_id"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "pfield_2 pl-2 pt-2" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.address,
                                  expression: "address"
                                }
                              ],
                              staticClass: "po_input col-12",
                              staticStyle: { "line-height": "27px" },
                              attrs: { type: "text", name: "address" },
                              domProps: { value: _vm.address },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.address = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c("div", { staticClass: "pfield_3 pl-2 pt-2" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.city,
                                  expression: "city"
                                }
                              ],
                              staticClass: "po_input col-12",
                              staticStyle: { "line-height": "27px" },
                              attrs: { type: "text", name: "city" },
                              domProps: { value: _vm.city },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.city = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pfield_4 pl-2 pt-2" },
                            [
                              _c("b-form-select", {
                                staticClass: "custom-select billingInput",
                                attrs: {
                                  options: _vm.state_options,
                                  name: "state"
                                },
                                model: {
                                  value: _vm.state,
                                  callback: function($$v) {
                                    _vm.state = $$v
                                  },
                                  expression: "state"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c("div", { staticClass: "pfield_5 pl-2 pt-2" }, [
                            _c("input", {
                              directives: [
                                {
                                  name: "model",
                                  rawName: "v-model",
                                  value: _vm.zip,
                                  expression: "zip"
                                }
                              ],
                              staticClass: "po_input col-12",
                              staticStyle: { "line-height": "27px" },
                              attrs: { type: "text", name: "zip" },
                              domProps: { value: _vm.zip },
                              on: {
                                input: function($event) {
                                  if ($event.target.composing) {
                                    return
                                  }
                                  _vm.zip = $event.target.value
                                }
                              }
                            })
                          ]),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pfield_6 pl-2  pt-2" },
                            [
                              _c("b-form-select", {
                                staticClass: "custom-select billingInput",
                                attrs: {
                                  options: _vm.country_options,
                                  name: "country"
                                },
                                model: {
                                  value: _vm.country,
                                  callback: function($$v) {
                                    _vm.country = $$v
                                  },
                                  expression: "country"
                                }
                              })
                            ],
                            1
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              staticClass: "pfield_7 text-center",
                              staticStyle: { "margin-top": "12px !important" }
                            },
                            [
                              _c("div", { staticClass: "chkboxwrapper" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "custom-control custom-checkbox"
                                  },
                                  [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.autoRenew,
                                          expression: "autoRenew"
                                        }
                                      ],
                                      ref: "autoRenew",
                                      staticClass: "custom-control-input",
                                      attrs: {
                                        type: "checkbox",
                                        id: "autoRenew",
                                        name: "autoRenew"
                                      },
                                      domProps: {
                                        checked: _vm.autoRenew,
                                        value: 1,
                                        checked: Array.isArray(_vm.autoRenew)
                                          ? _vm._i(_vm.autoRenew, 1) > -1
                                          : _vm.autoRenew
                                      },
                                      on: {
                                        change: function($event) {
                                          var $$a = _vm.autoRenew,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = 1,
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.autoRenew = $$a.concat([
                                                  $$v
                                                ]))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.autoRenew = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.autoRenew = $$c
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _c("label", {
                                      staticClass: "custom-control-label",
                                      attrs: { for: "autoRenew" }
                                    })
                                  ]
                                )
                              ])
                            ]
                          ),
                          _vm._v(" "),
                          _c(
                            "div",
                            { staticClass: "pfield_8 text-center pt-2" },
                            [
                              _c(
                                "button",
                                {
                                  staticClass: "btn btn-md ma-blue-btn",
                                  attrs: { type: "submit" },
                                  on: {
                                    click: function($event) {
                                      return _vm.onSubmitPaymentDetails()
                                    }
                                  }
                                },
                                [_vm._v("Update")]
                              )
                            ]
                          )
                        ]
                      )
                    ])
                  ])
                : _vm._e(),
              _vm._v(" "),
              _c("div", {
                staticClass: "mb-3",
                staticStyle: { clear: "both" }
              }),
              _vm._v(" "),
              _vm.unitType == "Seat" || _vm.unitType == "License"
                ? _c("div", [
                    _c("div", { staticClass: "col-12 p-0 heading mb-2" }, [
                      _vm._v("Subscription Forecast")
                    ]),
                    _vm._v(" "),
                    _c("div", { staticClass: "search-padd" }, [
                      _c("div", { staticClass: "col-12 override-padding" }, [
                        _vm.frequency == "monthly"
                          ? _c(
                              "div",
                              {
                                staticClass:
                                  "crm_admin_heading admin_h_1 text-align-center"
                              },
                              [_vm._v("Remaining")]
                            )
                          : _c(
                              "div",
                              {
                                staticClass:
                                  "crm_admin_heading admin_h_1 text-align-center"
                              },
                              [_vm._v("# of Purchase")]
                            ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "crm_admin_heading admin_h_2 text-align-center"
                          },
                          [_vm._v("Total Subscription")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "crm_admin_heading admin_h_3 text-align-center"
                          },
                          [_vm._v("Total Processed")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "crm_admin_heading admin_h_4 text-align-center"
                          },
                          [_vm._v("Total Due")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "crm_admin_heading admin_h_5 text-align-center"
                          },
                          [_vm._v("Auto-Renew")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "crm_admin_heading admin_h_6 text-align-center"
                          },
                          [_vm._v("Avg. $")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "crm_admin_heading admin_h_8 text-align-center"
                          },
                          [_vm._v("Onboarding Date")]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass:
                              "crm_admin_heading admin_h_7 text-align-center"
                          },
                          [_vm._v("Subscription Renewal")]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticStyle: { clear: "both" } }),
                      _vm._v(" "),
                      _c(
                        "div",
                        {
                          directives: [
                            {
                              name: "show",
                              rawName: "v-show",
                              value: _vm.loading,
                              expression: "loading"
                            }
                          ],
                          staticClass: "loading_show"
                        },
                        [
                          _c("div", {
                            staticClass: "spinner-border text-danger"
                          })
                        ]
                      ),
                      _vm._v(" "),
                      _vm.orderItems.length > 0
                        ? _c("div", { staticClass: "order_items" }, [
                            _vm.frequency == "monthly"
                              ? _c(
                                  "div",
                                  {
                                    staticClass:
                                      "crm_admin_field_lists admin_h_1 text-align-center"
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(_vm.totalOrders.noOfRemaining) +
                                        "\n      "
                                    )
                                  ]
                                )
                              : _c(
                                  "div",
                                  {
                                    staticClass:
                                      "crm_admin_field_lists admin_h_1 text-align-center"
                                  },
                                  [
                                    _vm._v(
                                      "\n          " +
                                        _vm._s(_vm.totalOrders.noOfPurchase) +
                                        "\n      "
                                    )
                                  ]
                                ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crm_admin_field_lists admin_h_2 text-align-center"
                              },
                              [
                                _vm._v(
                                  "\n          $" +
                                    _vm._s(_vm.totalOrders.totalOrderAmount) +
                                    "\n      "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crm_admin_field_lists admin_h_3 text-align-center"
                              },
                              [
                                _vm._v(
                                  "\n          $" +
                                    _vm._s(
                                      _vm.totalOrders.totalProcessedAmount
                                    ) +
                                    "\n      "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crm_admin_field_lists admin_h_4 text-align-center"
                              },
                              [
                                _vm._v(
                                  "\n          $" +
                                    _vm._s(_vm.totalOrders.totalDue) +
                                    "\n      "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crm_admin_field_lists admin_h_5 text-align-center"
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.totalOrders.autorenew) +
                                    "\n      "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crm_admin_field_lists admin_h_6 text-align-center"
                              },
                              [
                                _vm._v(
                                  "\n          $" +
                                    _vm._s(_vm.totalOrders.avgAmount) +
                                    "\n      "
                                )
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crm_admin_field_lists admin_h_8 text-align-center"
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(
                                      _vm.totalOrders.accountOnBoardingDate
                                    ) +
                                    "\n          "
                                ),
                                _vm.totalOrders.accountOnBoardingDateFlag == 0
                                  ? _c("a", {}, [
                                      _c("i", {
                                        staticClass: "fa fa-pencil",
                                        staticStyle: {
                                          color: "#00ACEE",
                                          cursor: "pointer"
                                        },
                                        attrs: { "aria-hidden": "true" },
                                        on: {
                                          click: function($event) {
                                            return _vm.openBoardingDateModal(
                                              _vm.totalOrders
                                                .accountOnBoardingDate
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c(
                              "div",
                              {
                                staticClass:
                                  "crm_admin_field_lists admin_h_7 text-align-center"
                              },
                              [
                                _vm._v(
                                  "\n          " +
                                    _vm._s(_vm.totalOrders.accountExpireDate) +
                                    " \n          "
                                ),
                                _vm.type == "yearly" && _vm.unitType == "Seat"
                                  ? _c("a", {}, [
                                      _c("i", {
                                        staticClass: "fa fa-pencil",
                                        staticStyle: {
                                          color: "#00ACEE",
                                          cursor: "pointer"
                                        },
                                        attrs: { "aria-hidden": "true" },
                                        on: {
                                          click: function($event) {
                                            return _vm.openRenewalDateModal(
                                              _vm.totalOrders.accountExpireDate
                                            )
                                          }
                                        }
                                      })
                                    ])
                                  : _vm._e()
                              ]
                            ),
                            _vm._v(" "),
                            _c("div", { staticStyle: { clear: "both" } })
                          ])
                        : _vm._e(),
                      _vm._v(" "),
                      _vm.orderItems.length == 0
                        ? _c(
                            "div",
                            { staticClass: "col-12 override-padding" },
                            [_vm._v("\n      No orders found\n    ")]
                          )
                        : _vm._e()
                    ]),
                    _vm._v(" "),
                    _vm.frequency == "monthly" && _vm.unitType == "Seat"
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "col-12 p-0 mt-3 heading" },
                            [_vm._v("Purchase History")]
                          ),
                          _vm._v(" "),
                          _vm._m(6),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.loading,
                                  expression: "loading"
                                }
                              ],
                              staticClass: "loading_show"
                            },
                            [
                              _c("div", {
                                staticClass: "spinner-border text-danger"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.orderItems.length > 0
                            ? _c(
                                "div",
                                { staticClass: "purchashed_items" },
                                _vm._l(_vm.orderItems, function(item, pindex) {
                                  return _c(
                                    "div",
                                    { staticClass: "purchase_items" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_1 text-align-center"
                                        },
                                        [
                                          _c("i", {
                                            class: _vm.getStatusIcon(
                                              item.orderStatus
                                            )
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.paymentMethod == "check"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_9 text-align-left"
                                            },
                                            [
                                              _vm._v(
                                                "\n            Check\n        "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_9 text-align-left"
                                            },
                                            [
                                              _vm._v(
                                                "\n            Credit card\n        "
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      item.isMonthlyBilling == 1
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_2 text-align-left"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "invoice_link",
                                                  attrs: {
                                                    href: "javascript:void(0);"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getMonthlyInvoicePdf(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.invoiceNo))]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_2 text-align-left"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "invoice_link",
                                                  attrs: {
                                                    href: "javascript:void(0);"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getInvoicePdf(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.invoiceNo))]
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_3 text-align-left"
                                        },
                                        [
                                          _vm._v(
                                            "\n          " +
                                              _vm._s(item.subscription) +
                                              "\n        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_4 text-align-left"
                                        },
                                        [
                                          _vm._v(
                                            "\n          " +
                                              _vm._s(item.schedule) +
                                              "\n        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_5 text-align-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n          $" +
                                              _vm._s(item.totalAmount) +
                                              "\n        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_6 text-align-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n          " +
                                              _vm._s(item.date) +
                                              "\n        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_7 text-align-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n          " +
                                              _vm._s(item.dueDate) +
                                              "\n        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !item.checkReceivedFlag &&
                                      item.paymentMethod == "check"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_8 text-align-left text-break"
                                            },
                                            [
                                              _vm._v(
                                                "\n          " +
                                                  _vm._s(
                                                    _vm.getPaymentStatus(
                                                      item.orderStatus
                                                    )
                                                  ) +
                                                  " \n        "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_8 text-align-left text-break"
                                            },
                                            [
                                              _vm._v(
                                                "\n          " +
                                                  _vm._s(
                                                    _vm.getPaymentStatus(
                                                      item.orderStatus
                                                    )
                                                  ) +
                                                  " \n        "
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticStyle: { clear: "both" }
                                      })
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.orderItems.length == 0
                            ? _c(
                                "div",
                                { staticClass: "col-12 override-padding" },
                                [_vm._v("\n      No orders found\n    ")]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.frequency == "yearly" && _vm.unitType == "Seat"
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "col-12 p-0 mt-3 heading" },
                            [_vm._v("Purchase History")]
                          ),
                          _vm._v(" "),
                          _vm._m(7),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.loading,
                                  expression: "loading"
                                }
                              ],
                              staticClass: "loading_show"
                            },
                            [
                              _c("div", {
                                staticClass: "spinner-border text-danger"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.orderItems.length > 0
                            ? _c(
                                "div",
                                { staticClass: "purchashed_items" },
                                _vm._l(_vm.orderItems, function(item, pindex) {
                                  return _c(
                                    "div",
                                    { staticClass: "purchase_items" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_1 text-align-center"
                                        },
                                        [
                                          _c("i", {
                                            class: _vm.getStatusIcon(
                                              item.orderStatus
                                            )
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.paymentMethod == "check"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_9_1 text-align-left"
                                            },
                                            [
                                              _vm._v(
                                                "\n            Check\n        "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_9_1 text-align-left"
                                            },
                                            [
                                              _vm._v(
                                                "\n            Credit card\n        "
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      item.isMonthlyBilling == 1
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_2 text-align-left"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "invoice_link",
                                                  attrs: {
                                                    href: "javascript:void(0);"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getMonthlyInvoicePdf(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.invoiceNo))]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_2 text-align-left"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "invoice_link",
                                                  attrs: {
                                                    href: "javascript:void(0);"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getInvoicePdf(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.invoiceNo))]
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_3_1 text-align-left"
                                        },
                                        [
                                          _vm._v(
                                            "\n          " +
                                              _vm._s(item.subscription) +
                                              "\n        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_5_1 text-align-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n          $" +
                                              _vm._s(item.totalAmount) +
                                              "\n        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_6_1 text-align-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n          " +
                                              _vm._s(item.date) +
                                              "\n        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !item.checkReceivedFlag &&
                                      item.paymentMethod == "check"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_8 text-align-left text-break"
                                            },
                                            [
                                              _vm._v(
                                                "\n          " +
                                                  _vm._s(
                                                    _vm.getPaymentStatus(
                                                      item.orderStatus
                                                    )
                                                  ) +
                                                  " \n        "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_2 text-align-left text-break"
                                            },
                                            [
                                              _vm._v(
                                                "\n          " +
                                                  _vm._s(
                                                    _vm.getPaymentStatus(
                                                      item.orderStatus
                                                    )
                                                  ) +
                                                  " "
                                              ),
                                              item.refundFlag == 1
                                                ? _c(
                                                    "span",
                                                    {
                                                      staticClass:
                                                        "badge badge-info text-uppercase",
                                                      staticStyle: {
                                                        "background-color":
                                                          "#FFA500"
                                                      }
                                                    },
                                                    [_vm._v("Refund")]
                                                  )
                                                : _vm._e()
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticStyle: { clear: "both" }
                                      })
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.orderItems.length == 0
                            ? _c(
                                "div",
                                { staticClass: "col-12 override-padding" },
                                [_vm._v("\n      No orders found\n    ")]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _vm.unitType == "License"
                      ? _c("div", [
                          _c(
                            "div",
                            { staticClass: "col-12 p-0 mt-3 heading" },
                            [_vm._v("Purchase History")]
                          ),
                          _vm._v(" "),
                          _vm._m(8),
                          _vm._v(" "),
                          _c("div", { staticStyle: { clear: "both" } }),
                          _vm._v(" "),
                          _c(
                            "div",
                            {
                              directives: [
                                {
                                  name: "show",
                                  rawName: "v-show",
                                  value: _vm.loading,
                                  expression: "loading"
                                }
                              ],
                              staticClass: "loading_show"
                            },
                            [
                              _c("div", {
                                staticClass: "spinner-border text-danger"
                              })
                            ]
                          ),
                          _vm._v(" "),
                          _vm.orderItems.length > 0
                            ? _c(
                                "div",
                                { staticClass: "purchashed_items" },
                                _vm._l(_vm.orderItems, function(item, pindex) {
                                  return _c(
                                    "div",
                                    { staticClass: "purchase_items" },
                                    [
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_1 text-align-center"
                                        },
                                        [
                                          _c("i", {
                                            class: _vm.getStatusIcon(
                                              item.orderStatus
                                            )
                                          })
                                        ]
                                      ),
                                      _vm._v(" "),
                                      item.paymentMethod == "check"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_9_1 text-align-left"
                                            },
                                            [
                                              _vm._v(
                                                "\n            Check\n        "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_9_1 text-align-left"
                                            },
                                            [
                                              _vm._v(
                                                "\n            Credit card\n        "
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      item.isMonthlyBilling == 1
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_2 text-align-left"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "invoice_link",
                                                  attrs: {
                                                    href: "javascript:void(0);"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getMonthlyInvoicePdf(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.invoiceNo))]
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_2 text-align-left"
                                            },
                                            [
                                              _c(
                                                "a",
                                                {
                                                  staticClass: "invoice_link",
                                                  attrs: {
                                                    href: "javascript:void(0);"
                                                  },
                                                  on: {
                                                    click: function($event) {
                                                      return _vm.getInvoicePdf(
                                                        item
                                                      )
                                                    }
                                                  }
                                                },
                                                [_vm._v(_vm._s(item.invoiceNo))]
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      item.noOfUnits == 1
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_3_1 text-align-left"
                                            },
                                            [
                                              _vm._v(
                                                "\n          " +
                                                  _vm._s(item.noOfUnits) +
                                                  " License\n        "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_3_1 text-align-left"
                                            },
                                            [
                                              _vm._v(
                                                "\n          " +
                                                  _vm._s(item.noOfUnits) +
                                                  " Licenses\n        "
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_5_1 text-align-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n          $" +
                                              _vm._s(item.totalAmount) +
                                              "\n        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      _c(
                                        "div",
                                        {
                                          staticClass:
                                            "crm_admin_field_lists orders_heading_6_1 text-align-center"
                                        },
                                        [
                                          _vm._v(
                                            "\n          " +
                                              _vm._s(item.date) +
                                              "\n        "
                                          )
                                        ]
                                      ),
                                      _vm._v(" "),
                                      !item.checkReceivedFlag &&
                                      item.paymentMethod == "check"
                                        ? _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_8 text-align-left text-break"
                                            },
                                            [
                                              _vm._v(
                                                "\n          " +
                                                  _vm._s(
                                                    _vm.getPaymentStatus(
                                                      item.orderStatus
                                                    )
                                                  ) +
                                                  " \n        "
                                              )
                                            ]
                                          )
                                        : _c(
                                            "div",
                                            {
                                              staticClass:
                                                "crm_admin_field_lists orders_heading_2 text-align-left text-break"
                                            },
                                            [
                                              _vm._v(
                                                "\n          " +
                                                  _vm._s(
                                                    _vm.getPaymentStatus(
                                                      item.orderStatus
                                                    )
                                                  ) +
                                                  " \n        "
                                              )
                                            ]
                                          ),
                                      _vm._v(" "),
                                      _c("div", {
                                        staticStyle: { clear: "both" }
                                      })
                                    ]
                                  )
                                }),
                                0
                              )
                            : _vm._e(),
                          _vm._v(" "),
                          _vm.orderItems.length == 0
                            ? _c(
                                "div",
                                { staticClass: "col-12 override-padding" },
                                [_vm._v("\n      No orders found\n    ")]
                              )
                            : _vm._e()
                        ])
                      : _vm._e(),
                    _vm._v(" "),
                    _c("div", {
                      staticClass: "margin-bottom-10",
                      staticStyle: { clear: "both" }
                    })
                  ])
                : _vm._e()
            ],
            1
          )
        : _vm._e(),
      _vm._v(" "),
      _c("RenewalDateChange", {
        ref: "RenewDateChangeModal",
        attrs: {
          isModalVisible: _vm.isRenewDateChangeModalVisible,
          accountId: _vm.accountId
        },
        on: {
          close: function($event) {
            _vm.isRenewDateChangeModalVisible = false
          }
        }
      }),
      _vm._v(" "),
      _c("BoardingDateChange", {
        ref: "BoardingDateChangeModal",
        attrs: {
          isModalVisible: _vm.isBoardingDateChangeModalVisible,
          accountId: _vm.accountId
        },
        on: {
          close: function($event) {
            _vm.isBoardingDateChangeModalVisible = false
          }
        }
      }),
      _vm._v(" "),
      _c(
        "BillingModal",
        {
          attrs: { isModalVisible: _vm.isBillingModalVisible },
          on: {
            close: function($event) {
              _vm.isBillingModalVisible = false
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n        Loading...\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v("Billing")]
          ),
          _vm._v(" "),
          _vm.isBillingModalVisible == true
            ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row pay_detail_row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12",
                      attrs: { id: "pay_detail_row" }
                    },
                    [
                      _c("div", { staticClass: "card card_info" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col",
                            staticStyle: { "padding-left": "7px" }
                          },
                          [
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "col-sm-5 col-form-label",
                                  attrs: { for: "check_no" }
                                },
                                [_vm._v("Total Amount:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-7" }, [
                                _vm._v("\n                    $"),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.total_display_amount,
                                      expression: "total_display_amount"
                                    }
                                  ],
                                  staticClass: "form-control billingInput",
                                  staticStyle: {
                                    width: "202px",
                                    display: "inline-block"
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "total_display_amount",
                                    name: "total_display_amount",
                                    disabled: "true"
                                  },
                                  domProps: { value: _vm.total_display_amount },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.total_display_amount =
                                        $event.target.value
                                    }
                                  }
                                })
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          { staticClass: "card-header purchasing_header" },
                          [
                            _c(
                              "div",
                              { staticClass: "card-title purchase_title" },
                              [_vm._v("Payment Method")]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "card-body purchasing_body",
                            attrs: { id: "billing_form_cc" }
                          },
                          [
                            _c(
                              "form",
                              {
                                staticClass: "mt-0",
                                attrs: { id: "card_form", autocomplete: "off" }
                              },
                              [
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-12 col-md-12 pr-0" },
                                    [
                                      _c("div", { staticClass: "radio" }, [
                                        _c(
                                          "label",
                                          { staticClass: "radio_input" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "validate",
                                                  rawName: "v-validate",
                                                  value: "required",
                                                  expression: "'required'"
                                                },
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.paymentMethod,
                                                  expression: "paymentMethod"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                value: "credit_card",
                                                name: "payment_method"
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.paymentMethod,
                                                  "credit_card"
                                                )
                                              },
                                              on: {
                                                click: _vm.choosePaymentMode,
                                                change: function($event) {
                                                  _vm.paymentMethod =
                                                    "credit_card"
                                                }
                                              }
                                            }),
                                            _vm._v(
                                              " Credit Cards (Process Online)\n                        "
                                            )
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.isCheckPanel == true
                                          ? _c("div", {
                                              staticClass: "payment_mode_opt",
                                              staticStyle: { display: "block" },
                                              attrs: { id: "card_info" }
                                            })
                                          : _vm._e()
                                      ])
                                    ]
                                  )
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "row" }, [
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-12  pr-0" },
                                    [
                                      _c("div", { staticClass: "radio" }, [
                                        _c(
                                          "label",
                                          { staticClass: "radio_input" },
                                          [
                                            _c("input", {
                                              directives: [
                                                {
                                                  name: "model",
                                                  rawName: "v-model",
                                                  value: _vm.paymentMethod,
                                                  expression: "paymentMethod"
                                                }
                                              ],
                                              attrs: {
                                                type: "radio",
                                                name: "payment_method",
                                                value: "check"
                                              },
                                              domProps: {
                                                checked: _vm._q(
                                                  _vm.paymentMethod,
                                                  "check"
                                                )
                                              },
                                              on: {
                                                click: _vm.choosePaymentMode,
                                                change: function($event) {
                                                  _vm.paymentMethod = "check"
                                                }
                                              }
                                            }),
                                            _vm._v(" Check (Mail In)")
                                          ]
                                        ),
                                        _vm._v(" "),
                                        _vm.verrors.firstByRule(
                                          "payment_method",
                                          "required"
                                        )
                                          ? _c(
                                              "div",
                                              {
                                                staticClass:
                                                  "margin-bottom-5 validate-warning-msg"
                                              },
                                              [
                                                _vm._v(
                                                  "You must choose a payment method"
                                                )
                                              ]
                                            )
                                          : _vm._e()
                                      ])
                                    ]
                                  )
                                ])
                              ]
                            )
                          ]
                        ),
                        _vm._v(" "),
                        _vm.isCreditPanel == true
                          ? _c(
                              "div",
                              {
                                staticClass: "col",
                                staticStyle: {
                                  "padding-left": "7px",
                                  display: "block"
                                },
                                attrs: { id: "check_info" }
                              },
                              [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-5 col-form-label",
                                      attrs: { for: "is_check_received" }
                                    },
                                    [_vm._v("Check Received:")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-sm-7 pt-2" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.checkReceived,
                                          expression: "checkReceived"
                                        }
                                      ],
                                      ref: "check_received_flag",
                                      attrs: {
                                        type: "checkbox",
                                        id: "is_check_received",
                                        value: "1",
                                        disabled: _vm.isCheckPanel
                                      },
                                      domProps: {
                                        checked: Array.isArray(
                                          _vm.checkReceived
                                        )
                                          ? _vm._i(_vm.checkReceived, "1") > -1
                                          : _vm.checkReceived
                                      },
                                      on: {
                                        click: function($event) {
                                          return _vm.chooseCheckReceived($event)
                                        },
                                        change: function($event) {
                                          var $$a = _vm.checkReceived,
                                            $$el = $event.target,
                                            $$c = $$el.checked ? true : false
                                          if (Array.isArray($$a)) {
                                            var $$v = "1",
                                              $$i = _vm._i($$a, $$v)
                                            if ($$el.checked) {
                                              $$i < 0 &&
                                                (_vm.checkReceived = $$a.concat(
                                                  [$$v]
                                                ))
                                            } else {
                                              $$i > -1 &&
                                                (_vm.checkReceived = $$a
                                                  .slice(0, $$i)
                                                  .concat($$a.slice($$i + 1)))
                                            }
                                          } else {
                                            _vm.checkReceived = $$c
                                          }
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.isCheckReceivedValidateMsg
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "margin-bottom-5 validate-warning-msg"
                                          },
                                          [_vm._v("Check Received is required")]
                                        )
                                      : _vm._e()
                                  ])
                                ]),
                                _vm._v(" "),
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-5 col-form-label",
                                      attrs: { for: "check_no" }
                                    },
                                    [_vm._v("Check Number:")]
                                  ),
                                  _vm._v(" "),
                                  _c("div", { staticClass: "col-sm-7" }, [
                                    _c("input", {
                                      directives: [
                                        {
                                          name: "model",
                                          rawName: "v-model",
                                          value: _vm.checkNumber,
                                          expression: "checkNumber"
                                        }
                                      ],
                                      staticClass: "form-control billingInput",
                                      staticStyle: { width: "210px" },
                                      attrs: {
                                        type: "text",
                                        maxlength: "10",
                                        id: "check_no",
                                        name: "check_number",
                                        disabled: _vm.isCheckPanel
                                      },
                                      domProps: { value: _vm.checkNumber },
                                      on: {
                                        blur: function($event) {
                                          return _vm.validateCheckNumber($event)
                                        },
                                        input: function($event) {
                                          if ($event.target.composing) {
                                            return
                                          }
                                          _vm.checkNumber = $event.target.value
                                        }
                                      }
                                    }),
                                    _vm._v(" "),
                                    _vm.isCheckNumberValidateMsg
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "margin-bottom-5 validate-warning-msg"
                                          },
                                          [_vm._v("Check Number is required")]
                                        )
                                      : _vm._e(),
                                    _vm._v(" "),
                                    _vm.isCheckNumberNumericMsg
                                      ? _c(
                                          "div",
                                          {
                                            staticClass:
                                              "margin-bottom-5 validate-warning-msg"
                                          },
                                          [_vm._v("Check Number be numeric")]
                                        )
                                      : _vm._e()
                                  ])
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCreditPanel == true
                          ? _c(
                              "div",
                              {
                                staticClass: "col",
                                staticStyle: { "padding-left": "7px" }
                              },
                              [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-5 col-form-label",
                                      attrs: { for: "check_no" }
                                    },
                                    [_vm._v("Onboarding Date:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-7" },
                                    [
                                      _c("date-picker", {
                                        attrs: {
                                          format: "MM/DD/YYYY",
                                          clearable: false,
                                          "input-class":
                                            "col-md-12 input-height-30 padding-lr-5 custom-datepicker"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "icon-calendar",
                                            fn: function() {
                                              return [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-calendar red-color",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ]),
                                        model: {
                                          value: _vm.onboarding_date,
                                          callback: function($$v) {
                                            _vm.onboarding_date = $$v
                                          },
                                          expression: "onboarding_date"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e(),
                        _vm._v(" "),
                        _vm.isCreditPanel == true
                          ? _c(
                              "div",
                              {
                                staticClass: "col",
                                staticStyle: { "padding-left": "7px" }
                              },
                              [
                                _c("div", { staticClass: "form-group row" }, [
                                  _c(
                                    "label",
                                    {
                                      staticClass: "col-sm-5 col-form-label",
                                      attrs: { for: "check_no" }
                                    },
                                    [_vm._v("Expiration Date:")]
                                  ),
                                  _vm._v(" "),
                                  _c(
                                    "div",
                                    { staticClass: "col-sm-7" },
                                    [
                                      _c("date-picker", {
                                        attrs: {
                                          "disabled-date": _vm.notBeforeToday,
                                          format: "MM/DD/YYYY",
                                          clearable: false,
                                          "input-class":
                                            "col-md-12 input-height-30 padding-lr-5 custom-datepicker"
                                        },
                                        scopedSlots: _vm._u([
                                          {
                                            key: "icon-calendar",
                                            fn: function() {
                                              return [
                                                _c("i", {
                                                  staticClass:
                                                    "fa fa-calendar red-color",
                                                  attrs: {
                                                    "aria-hidden": "true"
                                                  }
                                                })
                                              ]
                                            },
                                            proxy: true
                                          }
                                        ]),
                                        model: {
                                          value:
                                            _vm.new_account_expiration_date,
                                          callback: function($$v) {
                                            _vm.new_account_expiration_date = $$v
                                          },
                                          expression:
                                            "new_account_expiration_date"
                                        }
                                      })
                                    ],
                                    1
                                  )
                                ])
                              ]
                            )
                          : _vm._e()
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row justify-content-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary customBtn mt-3",
                            attrs: { disabled: _vm.disable_purchase_btn },
                            on: {
                              click: function($event) {
                                return _vm.processPayment()
                              }
                            }
                          },
                          [_vm._v("Apply Billing")]
                        )
                      ])
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      ),
      _vm._v(" "),
      _c(
        "CheckReceivedOrderUpdateModal",
        {
          attrs: { isModalVisible: _vm.isCheckOrderUpdateModal },
          on: {
            close: function($event) {
              return _vm.closeCheckOrderUpdateModal()
            }
          }
        },
        [
          _vm.loading
            ? _c("span", { staticClass: "pull-right text-danger" }, [
                _vm._v("\n        Loading...\n      ")
              ])
            : _vm._e(),
          _vm._v(" "),
          _c(
            "div",
            {
              staticClass: "sub-heading",
              attrs: { slot: "header" },
              slot: "header"
            },
            [_vm._v("Check Received")]
          ),
          _vm._v(" "),
          _vm.isCheckOrderUpdateModal == true
            ? _c("div", { attrs: { slot: "body" }, slot: "body" }, [
                _c("div", { staticClass: "row pay_detail_row" }, [
                  _c(
                    "div",
                    {
                      staticClass: "col-md-12",
                      attrs: { id: "pay_detail_row" }
                    },
                    [
                      _c("div", { staticClass: "card card_info" }, [
                        _c(
                          "div",
                          {
                            staticClass: "col",
                            staticStyle: { "padding-left": "7px" }
                          },
                          [
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "col-sm-5 col-form-label",
                                  attrs: { for: "check_no" }
                                },
                                [_vm._v("Total Amount:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-7" }, [
                                _vm._v("\n                    $"),
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.orderTotalAmount,
                                      expression: "orderTotalAmount"
                                    }
                                  ],
                                  staticClass: "form-control billingInput",
                                  staticStyle: {
                                    width: "202px",
                                    display: "inline-block"
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "total_display_amount",
                                    name: "total_display_amount",
                                    disabled: "true"
                                  },
                                  domProps: { value: _vm.orderTotalAmount },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.orderTotalAmount = $event.target.value
                                    }
                                  }
                                })
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col",
                            staticStyle: { "padding-left": "7px" }
                          },
                          [
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "col-sm-5 col-form-label",
                                  attrs: { for: "check_no" }
                                },
                                [_vm._v("Invoice No:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-7" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.orderInvoiceNo,
                                      expression: "orderInvoiceNo"
                                    }
                                  ],
                                  staticClass: "form-control billingInput",
                                  staticStyle: {
                                    width: "210px",
                                    display: "inline-block"
                                  },
                                  attrs: {
                                    type: "text",
                                    id: "orderInvoiceNo",
                                    name: "orderInvoiceNo",
                                    disabled: "true"
                                  },
                                  domProps: { value: _vm.orderInvoiceNo },
                                  on: {
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.orderInvoiceNo = $event.target.value
                                    }
                                  }
                                })
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col",
                            staticStyle: {
                              "padding-left": "7px",
                              display: "block"
                            },
                            attrs: { id: "check_info" }
                          },
                          [
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "col-sm-5 col-form-label",
                                  attrs: { for: "check_no" }
                                },
                                [_vm._v("Check Number:")]
                              ),
                              _vm._v(" "),
                              _c("div", { staticClass: "col-sm-7" }, [
                                _c("input", {
                                  directives: [
                                    {
                                      name: "validate",
                                      rawName: "v-validate",
                                      value: "required|numeric",
                                      expression: "'required|numeric'"
                                    },
                                    {
                                      name: "model",
                                      rawName: "v-model",
                                      value: _vm.checkNumber,
                                      expression: "checkNumber"
                                    }
                                  ],
                                  staticClass: "form-control billingInput",
                                  staticStyle: { width: "210px" },
                                  attrs: {
                                    type: "text",
                                    maxlength: "10",
                                    id: "check_no",
                                    name: "check_number"
                                  },
                                  domProps: { value: _vm.checkNumber },
                                  on: {
                                    blur: function($event) {
                                      return _vm.validateCheckNumber($event)
                                    },
                                    input: function($event) {
                                      if ($event.target.composing) {
                                        return
                                      }
                                      _vm.checkNumber = $event.target.value
                                    }
                                  }
                                }),
                                _vm._v(" "),
                                _vm.verrors.firstByRule(
                                  "check_number",
                                  "required"
                                )
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "margin-bottom-5 validate-warning-msg"
                                      },
                                      [_vm._v("Check No is required")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.verrors.firstByRule(
                                  "check_number",
                                  "numeric"
                                )
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "margin-bottom-5 validate-warning-msg"
                                      },
                                      [_vm._v("Check No should be numeric")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isCheckNumberValidateMsg
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "margin-bottom-5 validate-warning-msg"
                                      },
                                      [_vm._v("Check Number is required")]
                                    )
                                  : _vm._e(),
                                _vm._v(" "),
                                _vm.isCheckNumberNumericMsg
                                  ? _c(
                                      "div",
                                      {
                                        staticClass:
                                          "margin-bottom-5 validate-warning-msg"
                                      },
                                      [_vm._v("Check Number be numeric")]
                                    )
                                  : _vm._e()
                              ])
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col",
                            staticStyle: { "padding-left": "7px" }
                          },
                          [
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "col-sm-5 col-form-label",
                                  attrs: { for: "check_no" }
                                },
                                [_vm._v("Onboarding Date:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-sm-7" },
                                [
                                  _c("date-picker", {
                                    attrs: {
                                      format: "MM/DD/YYYY",
                                      clearable: false,
                                      "input-class":
                                        "col-md-12 input-height-30 padding-lr-5 custom-datepicker"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "icon-calendar",
                                        fn: function() {
                                          return [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-calendar red-color",
                                              attrs: { "aria-hidden": "true" }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ]),
                                    model: {
                                      value: _vm.onboarding_date,
                                      callback: function($$v) {
                                        _vm.onboarding_date = $$v
                                      },
                                      expression: "onboarding_date"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        ),
                        _vm._v(" "),
                        _c(
                          "div",
                          {
                            staticClass: "col",
                            staticStyle: { "padding-left": "7px" }
                          },
                          [
                            _c("div", { staticClass: "form-group row" }, [
                              _c(
                                "label",
                                {
                                  staticClass: "col-sm-5 col-form-label",
                                  attrs: { for: "check_no" }
                                },
                                [_vm._v("Expiration Date:")]
                              ),
                              _vm._v(" "),
                              _c(
                                "div",
                                { staticClass: "col-sm-7" },
                                [
                                  _c("date-picker", {
                                    attrs: {
                                      "disabled-date": _vm.notBeforeToday,
                                      format: "MM/DD/YYYY",
                                      clearable: false,
                                      "input-class":
                                        "col-md-12 input-height-30 padding-lr-5 custom-datepicker"
                                    },
                                    scopedSlots: _vm._u([
                                      {
                                        key: "icon-calendar",
                                        fn: function() {
                                          return [
                                            _c("i", {
                                              staticClass:
                                                "fa fa-calendar red-color",
                                              attrs: { "aria-hidden": "true" }
                                            })
                                          ]
                                        },
                                        proxy: true
                                      }
                                    ]),
                                    model: {
                                      value: _vm.new_account_expiration_date,
                                      callback: function($$v) {
                                        _vm.new_account_expiration_date = $$v
                                      },
                                      expression: "new_account_expiration_date"
                                    }
                                  })
                                ],
                                1
                              )
                            ])
                          ]
                        )
                      ]),
                      _vm._v(" "),
                      _c("div", { staticClass: "row justify-content-center" }, [
                        _c(
                          "button",
                          {
                            staticClass: "btn btn-primary customBtn mt-3",
                            attrs: { disabled: _vm.disable_purchase_btn },
                            on: {
                              click: function($event) {
                                return _vm.updatePaymentStatus()
                              }
                            }
                          },
                          [_vm._v("Update")]
                        )
                      ])
                    ]
                  )
                ])
              ])
            : _vm._e(),
          _vm._v(" "),
          _c("div", {
            staticClass: "col-3 override-padding",
            attrs: { slot: "footer" },
            slot: "footer"
          })
        ]
      )
    ],
    1
  )
}
var staticRenderFns = [
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "row" }, [
      _c("div", { staticClass: "col-12" }, [
        _c(
          "div",
          {
            staticClass: "alert alert-danger",
            staticStyle: { "margin-top": "10px" }
          },
          [
            _vm._v(
              "\n          Pricing is not assigned to this Account. Please select pricing from Affiliate Tab.\n        "
            )
          ]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-padd" }, [
      _c("div", { staticClass: "col-12 override-padding" }, [
        _c("div", { staticClass: "crm_admin_heading nafield_1 pl-2" }, [
          _vm._v("Billing Frequency")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_2 pl-2" }, [
          _vm._v("Bundle")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_3 pl-2" }, [
          _vm._v("Additional Mentees")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_4 pl-2" }, [
          _vm._v("Bundle Rate")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_8 pl-2" }, [
          _vm._v("Override Price")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_5 pl-2" }, [
          _vm._v("Mentee Rate")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_6 pl-2" }, [
          _vm._v("Total Price")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_7 text-center" }, [
          _vm._v(" ")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-padd" }, [
      _c("div", { staticClass: "col-12 override-padding" }, [
        _c(
          "div",
          { staticClass: "crm_admin_heading nafield_l_1 pl-2  text-center" },
          [_vm._v("Unit Type")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_l_2 pl-2" }, [
          _vm._v("Unit")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_l_3 pl-2" }, [
          _vm._v("Price")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_l_6 pl-2" }, [
          _vm._v("Override Price")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading nafield_l_4 pl-2" }, [
          _vm._v("Total Price")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "crm_admin_heading nafield_l_5 text-center" },
          [_vm._v("Subscription")]
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-padd" }, [
      _c("div", { staticClass: "col-12 override-padding" }, [
        _c(
          "div",
          { staticClass: "crm_admin_heading field_l_1 pl-2  text-center" },
          [_vm._v("Unit Type")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading field_l_2 pl-2" }, [
          _vm._v("Unit")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading field_l_3 pl-2" }, [
          _vm._v("Price")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading field_l_4 pl-2" }, [
          _vm._v("Total Price")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading field_l_5 text-center" }, [
          _vm._v("Subscription")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 pt-3" }, [
      _c("i", [
        _vm._v(
          "Last monthly billing transaction is pending, so billing frequency and bundle field is disabled. "
        )
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "search-padd" }, [
      _c("div", { staticClass: "col-12 override-padding" }, [
        _c("div", { staticClass: "crm_admin_heading pfield_1 pl-2" }, [
          _vm._v("Payment Method")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading pfield_2 pl-2" }, [
          _vm._v("Billing Information")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading pfield_3 pl-2" }, [
          _vm._v(" ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading pfield_4 pl-2" }, [
          _vm._v(" ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading pfield_5 pl-2" }, [
          _vm._v(" ")
        ]),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading pfield_6 pl-2" }, [
          _vm._v(" ")
        ]),
        _vm._v(" "),
        _c(
          "div",
          { staticClass: "crm_admin_heading pfield_7 text-center  pl-2" },
          [_vm._v("Auto-Renew")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "crm_admin_heading pfield_8 text-center" }, [
          _vm._v("Subscription")
        ])
      ])
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 override-padding mt-2" }, [
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_1 text-align-center" },
        [_vm._v("Status")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_9 text-align-left" },
        [_vm._v("Payment Method")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_2 text-align-left" },
        [_vm._v("Invoice #")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_3 text-align-left" },
        [_vm._v("Subscription")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_4 text-align-left" },
        [_vm._v("Billing Schedule")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_5 text-align-center" },
        [_vm._v("Total Amount")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_6 text-align-center" },
        [_vm._v("Invoice Date")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_7 text-align-center" },
        [_vm._v("Due Date")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_8 text-align-left" },
        [_vm._v("Status")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 override-padding mt-2" }, [
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_1 text-align-center" },
        [_vm._v("Status")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_9_1 text-align-left" },
        [_vm._v("Payment Method")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_2 text-align-left" },
        [_vm._v("Invoice #")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_3_1 text-align-left" },
        [_vm._v("Subscription")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "crm_admin_heading orders_heading_5_1 text-align-center"
        },
        [_vm._v("Total Amount")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "crm_admin_heading orders_heading_6_1 text-align-center"
        },
        [_vm._v("Invoice Date")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_8 text-align-left" },
        [_vm._v("Status")]
      )
    ])
  },
  function() {
    var _vm = this
    var _h = _vm.$createElement
    var _c = _vm._self._c || _h
    return _c("div", { staticClass: "col-12 override-padding mt-2" }, [
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_1 text-align-center" },
        [_vm._v("Status")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_9_1 text-align-left" },
        [_vm._v("Payment Method")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_2 text-align-left" },
        [_vm._v("Invoice #")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_3_1 text-align-left" },
        [_vm._v("Purchase")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "crm_admin_heading orders_heading_5_1 text-align-center"
        },
        [_vm._v("Total Amount")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass: "crm_admin_heading orders_heading_6_1 text-align-center"
        },
        [_vm._v("Invoice Date")]
      ),
      _vm._v(" "),
      _c(
        "div",
        { staticClass: "crm_admin_heading orders_heading_8 text-align-left" },
        [_vm._v("Status")]
      )
    ])
  }
]
render._withStripped = true
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports
if (module.hot) {
  module.hot.accept()
  if (module.hot.data) {
    require("vue-hot-reload-api")      .rerender("data-v-720f03ae", esExports)
  }
}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-720f03ae","hasScoped":true,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/admin/account_lookup_billing_tab.vue
// module id = null
// module chunks = 